import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
export const Text = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {any} [props.as]
 * @param {any} props.children
 * @param {"white" | "light" | "secondary" | "secondary-white" | "secondary-light" | "primary"} [props.variant]
 * @param {any} [props.className]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Text({
  as: El,
  children,
  variant,
  className,
  ...props
}, ref) {
  const textClass = classNames({
    "mb-4": El === "p",
    "text-sm": variant && variant.includes("secondary"),
    "text-en-gray-600": variant && variant.includes("light"),
    "text-white": variant && variant.includes("white"),
    "text-en-gray-800": !variant || !variant.includes("white") && !variant.includes("light")
  }, className);
  return /*#__PURE__*/React.createElement(El, _extends({
    className: textClass
  }, props, {
    ref: ref
  }), children);
});
Text.defaultProps = {
  as: "p",
  // @ts-ignore
  variant: "primary"
};
Text.propTypes = {
  as: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.elementType]),
  children: PropTypes.node,
  // @ts-ignore
  variant: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};